export const identification = [
  { value: "drivers_license", text: "運転免許証" },
  { value: "insurance_card", text: "保険証" },
  { value: "passport", text: "パスポート" },
  { value: "my_number_card", text: "マイナンバーカード" },
  { value: "citizen_identification_card", text: "住民基本台帳カード" },
  { value: "residence_card", text: "在留カード" }
];
